module.exports = __webpack_public_path__ + "img/updates.39898db2.png";